module.exports = __webpack_public_path__ + "static/media/gp-sp2025.50d7b1db.png";